import { logger as garnishLogger } from '@garnish/logger';

garnishLogger.enable('REMOTE_ASSET_MACHINE');

export const log = garnishLogger.extend('REMOTE_ASSET_MACHINE');
